export const CreateSupplementTitleBar = {
	title: "Thêm chi phí mới",
	cancelButton: "Huỷ bỏ",
	addButton: "Lưu chi phí",
};
